<template>
  <div class="custom-scrollbar mt-12 overflow-hidden">
    <div class="relative min-w-0 pb-[56px] xl:min-h-[552px]">
      <template v-if="!isMobile && items?.length">
        <ClientOnly>
          <Swiper
            :slides-per-view="'auto'"
            class="flex w-full"
            @swiper="onSwiper"
          >
            <SwiperSlide
              v-for="(monthItems, idx) in items"
              :key="`event-${idx}`"
            >
              <CardsTimelineCard
                :items="monthItems"
                :month="idx"
                is-timeline
                class="timeline-card"
                :class="[
                  { 'line-first': idx === 0 },
                  { 'reverse-card': idx % 2 === 0 && !isMobile },
                  {
                    'line-last': idx + 1 === items.length,
                  },
                ]"
              />
            </SwiperSlide>
          </Swiper>
        </ClientOnly>
      </template>
      <template v-else-if="isMobile && items?.length">
        <CardsTimelineCard
          v-for="(monthItems, idx) in items"
          :key="`event-${idx}`"
          :items="monthItems"
          :month="idx"
          class="timeline-card"
          :class="[
            { 'line-first': idx === 0 },
            { 'reverse-card': idx % 2 === 0 && !isMobile },
            {
              'line-last': idx + 1 === items.length,
            },
          ]"
          is-timeline
        />
      </template>
      <div v-else class="grid place-content-center">
        <ClientOnly>
          <img
            v-lazy-load
            src="/imgs/loading.svg"
            class="size-[150px] border-none"
          />
        </ClientOnly>
      </div>
      <!-- <template v-else>
        <CardsTimelineCard
          v-for="(monthItems, idx) in items"
          :key="`event-${idx}`"
          :items="monthItems"
          :month="idx"
          class="timeline-card"
          :class="[
            { 'line-first': idx === 0 },
            { 'reverse-card': idx % 2 === 0 && !isMobile },
            {
              'line-last': idx + 1 === items.length,
            },
          ]"
          is-timeline
        />
      </template> -->
    </div>
    <div class="flex">
      <SlidersSliderControl
        v-if="items.length"
        type="prev"
        class="ml-auto mr-3 hidden size-8 md:block"
        :class="[isBeginning ? 'opacity-50' : 'cursor-pointer']"
        @click="slidePrev()"
      />
      <SlidersSliderControl
        v-if="items.length"
        type="next"
        class="hidden size-8 md:block"
        :class="[isEnd ? 'opacity-50' : 'cursor-pointer']"
        @click="slideNext()"
      />
    </div>
  </div>
</template>

<script setup>
import 'swiper/css';

import { Swiper, SwiperSlide } from 'swiper/vue';

defineProps({
  items: {
    type: Array,
    default: () => [],
  },
});

const { isMobile } = useBreakpoint();

const { onSwiper, slideNext, slidePrev, isEnd, isBeginning } = useSwiper();
</script>

<style lang="scss">
.swiper-slide {
  @apply w-fit;
}
.timeline-card {
  @apply md:h-[364px] md:min-w-[248px] xl:h-[464px] xl:min-w-[270px] w-full xl:max-w-[270px] shrink-0;
}
</style>
